export default __webpack_public_path__ + "static/media/banner4.823c9de2.jpg";